<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="background: #ecf0f5">
        <SideBar/>
        <Header/>
        <v-container fluid>
            <v-row style="margin-top: -20px" dense>
                <v-col>
                    <v-breadcrumbs :items="items" light>
                        <template v-slot:divider>
                            <v-icon small>$vuetify.icons.values.mdiChevronRight</v-icon>
                        </template>
                    </v-breadcrumbs>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4" lg="4">
                    <span><v-icon large class="mr-3">$vuetify.icons.values.mdiChartBar</v-icon></span>
                    <span> Outstanding Scholar Assessment (OSA)</span>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                    <v-select
                            label="Select Year"
                            solo
                            chips
                            deletable-chips
                            small-chips
                    :items="items1">

                    </v-select>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="6" lg="6">
                    <v-card color="#9896c7" dark width="">
                        <v-list-item three-line>
                            <v-list-item-avatar tile color="#9896c7">
                                <v-icon dark>$vuetify.icons.values.mdiAccountGroupOutline</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="mb-1"><span class="display-2">25</span><span class="font-weight-regular">&nbsp;{{$t('msg.registered_employees_text')}}</span></v-list-item-title>
                                <v-progress-linear value="100" color="white"/>
                                <!--                <v-list-item-subtitle>50% Higher than Last Week</v-list-item-subtitle>-->
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                    <v-card color="#48c9b0" dark width="">
                        <v-list-item three-line>
                            <v-list-item-avatar tile color="#48c9b0">
                                <v-icon dark>$vuetify.icons.values.mdiFileDocument</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="mb-1"><span class="display-2">12</span><span class="font-weight-regular">&nbsp;{{$t('msg.finished_employees_text')}} </span></v-list-item-title>
                                <v-progress-linear value="100" color="white"/>
                                <!--                <v-list-item-subtitle>50% Higher than Last Week</v-list-item-subtitle>-->
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="12" lg="12">
                    <v-card style="border-top: 3px solid #44c1ef">
                        <v-toolbar
                                color="white"
                                light
                                flat
                        >
                            <v-icon color="blue">$vuetify.icons.values.mdiChartBar</v-icon>

                            <v-toolbar-title class="ml-3">Test Takers</v-toolbar-title>
                        </v-toolbar>
<!--                        <BarChart :options="chartOptions"></BarChart>-->
                        <DonutPieChart :options="pieChart"></DonutPieChart>
                    </v-card>
                </v-col>
                <!--<v-col cols="12" md="6" lg="6">
                    <v-card style="border-top: 3px solid #44c1ef">
                        <v-toolbar
                                color="white"
                                light
                                flat
                        >
                            <v-icon color="blue">$vuetify.icons.values.mdiChartBar</v-icon>

                            <v-toolbar-title class="ml-3">External Aspects</v-toolbar-title>
                        </v-toolbar>
                        <BarChart :options="chartOptions"></BarChart>
                    </v-card>
                </v-col>-->
            </v-row>
            <!--<v-row dense>
                <v-col cols="12" md="12" lg="12">
                    <v-card style="border-top: 3px solid #44c1ef">
                        <v-toolbar
                                color="white"
                                light
                                flat
                        >
                            <v-icon color="blue">$vuetify.icons.values.mdiChartBar</v-icon>

                            <v-toolbar-title class="ml-3">Factors</v-toolbar-title>
                        </v-toolbar>
                        <v-row dense>
                            <v-col cols="12" md="6" lg="6" v-for="(chartData,i) in charts" v-bind:key="i">
                                <Chart v-for="index in chartData" v-bind:key="index" :options="index"></Chart>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>-->
        </v-container>
    </div>
</template>

<script>
    // import BarChart from '../charts/BarChart'
    import SideBar from "./SideBar"
    import Header from "./Header"
    import DonutPieChart from "../charts/DonutPieChart"

    export default {
        components: {

            // BarChart,
            SideBar,
            Header,
            DonutPieChart
        },
        name: 'Dashboard',
        data () {
            return {
                symbol: "<",
                symbol2: ">",
                items1:[
                    {
                        text: "2019"
                    },
                    {
                        text: "2020"
                    }
                ],
                items: [
                    {
                        text: 'Home',
                        disabled: true,
                        href: 'breadcrumbs_dashboar'
                    },
                    {
                        text: 'Dashboard',
                        disabled: true,
                        href: 'breadcrumbs_link_1'
                    }
                ],
                tab: null,
                e13: 1,
                pieChart: {
                    title: {
                        text: 'Total Test Takers: 25'
                    },
                    series: [
                        {
                            id: 'series1',
                            data: [
                                {
                                    y: 10,
                                    name: 'Not Started'
                                },
                                {
                                    y: 12,
                                    name: 'Completed'
                                },
                                {
                                    y: 3,
                                    name: 'Incomplete'
                                }
                            ]
                        }
                    ]
                },
                chartOptions: {
                    colors: ['#756aa0', '#53b7a9', '#338089', '#2298dd'],
                    chart: {
                        type: 'bar'
                    },
                    chartOptions:{
                      title: 'dsa'
                    },
                    xAxis: {
                        categories: ['']
                    },
                    yAxis: {
                        title: {
                            text: ''
                        }
                    },
                    series: [{
                        name: 'Registered',
                        data: [ 500 ]
                    },
                        {
                            name: 'Completed',
                            data: [ 350 ]
                        },
                        {
                            name: 'Incomplete',
                            data: [ 150 ]
                        }],
                    credits: {
                        enabled: false
                    }
                },
                charts: [
                    {
                        chart1: {
                            title: {
                                text: '460'
                            },
                            series: [
                                {
                                    id: 'series1',
                                    data: [
                                        {
                                            y: 40,
                                            name: 'test1'
                                        },
                                        {
                                            y: 70,
                                            name: 'test2'
                                        },
                                        {
                                            y: 55,
                                            name: 'test3'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        chart2: {
                            title: {
                                text: '520'
                            },
                            series: [
                                {
                                    id: 'series1',
                                    data: [
                                        {
                                            y: 10,
                                            name: 'test1'
                                        },
                                        {
                                            y: 20,
                                            name: 'test2'
                                        },
                                        {
                                            y: 35,
                                            name: 'test3'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        chart3: {
                            title: {
                                text: '250'
                            },
                            series: [
                                {
                                    id: 'series1',
                                    data: [
                                        {
                                            y: 10,
                                            name: 'test1'
                                        },
                                        {
                                            y: 20,
                                            name: 'test2'
                                        },
                                        {
                                            y: 35,
                                            name: 'test3'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        chart4: {
                            title: {
                                text: '300'
                            },
                            series: [
                                {
                                    id: 'series1',
                                    data: [
                                        {
                                            y: 10,
                                            name: 'test1'
                                        },
                                        {
                                            y: 20,
                                            name: 'test2'
                                        },
                                        {
                                            y: 35,
                                            name: 'test3'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        computed: {
            theme () {
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        }
    }
</script>
<style scoped>

</style>
